import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderNavigateService } from './services/order-navigate.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    OrderNavigateService
  ]
})
export class NavigationModule { }
